import { Button } from "reactstrap";
import { useState } from "react";
import BuyButtonComponent from "./BuyButtonComponent";
import Stripe from "../../Stripe/server";
import { Table } from "react-bootstrap";
import APIURL from "../../../helper/environment";

const LotTableRow = (props) => {
  const { name, _id } = props.parkingLot;
  const [isEditing, setIsEditing] = useState(false);
  const [editedName, setEditedName] = useState(name);
  const navigate = props.navigate;

  async function handleDelete() {
    let url = `${APIURL}/parking-lot/delete/` + _id;
    let myHeaders = new Headers();
    myHeaders.append("Authorization", props.token);
    let requestOptions = {
      headers: myHeaders,
      method: "DELETE",
    };
    try {
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      console.log("This is inside LotTableRow Delete", data);
      props.getAllLots();
    } catch (error) {
      console.error(error.message);
    }
  }

  async function handleEdit() {
    let url = `${APIURL}/parking-lot/edit/` + _id;
    let myHeaders = new Headers();
    myHeaders.append("Authorization", props.token);
    myHeaders.append("Content-Type", "application/json");
    let requestOptions = {
      headers: myHeaders,
      method: "PATCH",
      body: JSON.stringify({ name: editedName }),
    };
    try {
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      console.log("This is inside LotTableRow Edit", data);
      props.getAllLots();
      setIsEditing(false);
    } catch (error) {
      console.error(error.message);
    }
  }

  return (
    <tr>
      <td>{name}</td>
      <td>
        {isEditing ? (
          <div>
            <input
              type="text"
              value={editedName}
              onChange={(e) => setEditedName(e.target.value)}
            />
            <Button
              className="button-container"
              color="success"
              onClick={handleEdit}
            >
              Save
            </Button>
          </div>
        ) : (
          <div>
            <Button
              className="button-container"
              color="secondary"
              onClick={() => navigate("/ParkingSpaces/" + props.parkingLot._id)}
            >
              List of Spaces
            </Button>
            <Button
              className="button-container"
              color="primary"
              onClick={() => setIsEditing(true)}
            >
              Edit
            </Button>

            {/* <stripe-buy-button
              // buy-button-id=""
              buy-button-id="buy_btn_1NC7CYKK7HItAOBSSAW4tv42"
              publishable-key="pk_test_51N8mQTKK7HItAOBSoHWoChcqP53hzfnbFet65eQ3s7Bb7EDnqzmul6ZC5lieIcgdKNGtNAQsZ1LlxIAMtnxvrnm900dxmTPmsF"
            ></stripe-buy-button>
            <stripe-buy-button
              // buy-button-id=""
              buy-button-id="buy_btn_1NC5KdKK7HItAOBSb5LRyzJZ"
              publishable-key="pk_test_51N8mQTKK7HItAOBSoHWoChcqP53hzfnbFet65eQ3s7Bb7EDnqzmul6ZC5lieIcgdKNGtNAQsZ1LlxIAMtnxvrnm900dxmTPmsF"
            ></stripe-buy-button>
            <stripe-buy-button
              // buy-button-id=""
              buy-button-id="buy_btn_1NC7LwKK7HItAOBSRdz4BXPm"
              publishable-key="pk_test_51N8mQTKK7HItAOBSoHWoChcqP53hzfnbFet65eQ3s7Bb7EDnqzmul6ZC5lieIcgdKNGtNAQsZ1LlxIAMtnxvrnm900dxmTPmsF"
            ></stripe-buy-button> */}
            {/* <div>
              <Stripe product-id="{{prod_Nwppffn8XjqJOs}}" />
            </div> */}

            <Button
              className="button-container"
              color="danger"
              onClick={handleDelete}
            >
              Delete
            </Button>
          </div>
        )}
      </td>
      <div>
        <Button
          className="button-container"
          color="warning"
          href={"./Map"}
          role="button"
        >
          Map
        </Button>
      </div>
    </tr>
  );
};

export default LotTableRow;
